import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const myVideo = document.getElementById("video_vendre");
        const videoWrapper = document.querySelector(".o-video-wrapper");
        const playPauseButton = this.el;

        function updateControls() {
            if (window.innerWidth < 768) {
                myVideo.controls = true; // Toujours afficher les contrôles en dessous de 768px
            } else if (!myVideo.paused) {
                myVideo.controls = true; // Afficher les contrôles lorsque la vidéo est en lecture et au-dessus de 768px
            } else {
                myVideo.controls = false; // Masquer les contrôles lorsque la vidéo est en pause et au-dessus de 768px
            }
        }

        function playPause() {
            if (myVideo.paused) {
                myVideo.play();
                videoWrapper.classList.add("-active");
            } else {
                myVideo.pause();
                videoWrapper.classList.remove("-active");
            }
            updateControls();
        }

        // Ajouter un gestionnaire d'événements click au bouton play/pause
        playPauseButton.addEventListener("click", playPause);

        // Appeler updateControls lors du chargement initial et lors du redimensionnement de la fenêtre
        if (myVideo) {
            updateControls();
            window.addEventListener("resize", updateControls);
        }
    }
}